import React from 'react';
import { BUTTON_SHAPES, buildEmailAnchorInlineStyle } from '../../utils/emailButtonStyles';
import {
  normalizeHubupNotificationButtonColor as normHubup,
  normalizeHubupNotificationButtonLabel,
} from '../../utils/campaignEmailTemplate';
import InfoTooltip from '../ui/InfoTooltip';

export default function EmailButtonDesignFields({
  title = 'Style du bouton',
  titleTooltip = '',
  value,
  onChange,
  labelKey = 'buttonLabel',
  bgKey = 'buttonColor',
  borderKey = 'buttonBorderColor',
  textKey = 'buttonTextColor',
  shapeKey = 'buttonShape',
}) {
  const v = value || {};
  const set = (patch) => onChange({ ...v, ...patch });
  const bg = normHubup(v[bgKey] || '#111827');
  const border = normHubup(v[borderKey] || bg);
  const previewLabel = normalizeHubupNotificationButtonLabel(v[labelKey]);
  const previewStyle = buildEmailAnchorInlineStyle({
    backgroundColor: bg,
    borderColor: border,
    textColor: v[textKey],
    shape: v[shapeKey] || 'rounded',
  });

  return (
    <div className="space-y-3 rounded-lg border border-border bg-background p-3">
      <p className="flex items-center gap-1 text-xs font-semibold text-foreground">
        {title}
        {titleTooltip ? <InfoTooltip text={titleTooltip} /> : null}
      </p>
      <div className="rounded-md border border-dashed border-border bg-muted/30 px-3 py-4 text-center">
        <p className="mb-2 text-[10px] uppercase tracking-wide text-muted-foreground">
          Aperçu du bouton (comme dans l&apos;email)
        </p>
        <span
          className="pointer-events-none inline-block"
          style={{ lineHeight: 0 }}
          dangerouslySetInnerHTML={{
            __html: `<a href="#" style="${previewStyle}">${previewLabel.replace(/&/g, '&amp;').replace(/</g, '&lt;')}</a>`,
          }}
        />
      </div>
      <div>
        <label className="mb-1 block text-xs text-muted-foreground">Texte</label>
        <input
          type="text"
          value={v[labelKey] || ''}
          onChange={(e) => set({ [labelKey]: e.target.value })}
          className="w-full rounded-md border border-input px-3 py-2 text-sm"
        />
      </div>
      <div>
        <label className="mb-1 block text-xs text-muted-foreground">Forme</label>
        <select
          className="w-full rounded-md border border-input px-3 py-2 text-sm"
          value={v[shapeKey] || 'rounded'}
          onChange={(e) => set({ [shapeKey]: e.target.value })}
        >
          {BUTTON_SHAPES.map((s) => (
            <option key={s.id} value={s.id}>
              {s.label}
            </option>
          ))}
        </select>
      </div>
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
        <div>
          <label className="mb-1 block text-xs text-muted-foreground">Fond</label>
          <input
            type="color"
            className="h-10 w-full rounded-md border border-input"
            value={bg}
            onChange={(e) => set({ [bgKey]: e.target.value })}
          />
        </div>
        <div>
          <label className="mb-1 block text-xs text-muted-foreground">Bordure</label>
          <input
            type="color"
            className="h-10 w-full rounded-md border border-input"
            value={border}
            onChange={(e) => set({ [borderKey]: e.target.value })}
          />
        </div>
        <div>
          <label className="mb-1 block text-xs text-muted-foreground">Texte</label>
          <input
            type="color"
            className="h-10 w-full rounded-md border border-input"
            value={
              /^#[0-9a-fA-F]{6}$/.test(String(v[textKey] || ''))
                ? v[textKey]
                : '#ffffff'
            }
            onChange={(e) => set({ [textKey]: e.target.value })}
          />
        </div>
      </div>
    </div>
  );
}
